const initialValues = {
  // NEW FIELDS
  ticketId: "",
  workLocationCity: "",
  years: "",
  months: "",
  mailIdDomain: "",
  assetRequired: "",
  asset: "",

  noticePeriod: "",

  marketFacingTitle: "",
  lastName: "",
  gender: "",
  shift: "S1",
  experience: "",
  swipeMethod: "Bio Metric",
  ctc: "",
  personalEmailId: "",
  department: "",

  secondaryContactNumber: "",
  divisionHeadId: "",
  recruiterId: "",
  buddyId: "",

  reviewer: "",
  firstName: "",
  primaryContactNumber: "",
  primaryReportingManager: "",
  mailIdRequired: "Yes",
  subOrganization: "",
  rfh: "",
  roleOfIntake: "",
  organization: "",
  attendanceFormat: "Mon-Fri 5 days / week",
  grade: "",
  middleName: "",
  designation: null,
  weekOff: "Saturday-Alternative Full Day",
  doj: null,
  dob: null,

  probation: "",
  probationMonths: "",
  workLocation: "",
  manpowerOutsourcing: "No",
  mobileAccess: "",
  // leaveScheme: "",
  employeeType: "",
  // roleFamily:"",
  // dob: "",

  // REMOVED FIELDS
  // maritalStatus: null,
  // groupDOJ: "",
  // applyPF: "",
  // bloodGroup: null,
  // additionalReportingManager: "",

  // onboarderId: "",
};

export default initialValues;
